// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nn-0";